export default {"src":"/_next/static/media/cet_w.35df18fb.svg","height":445,"width":721};